"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMillisecondsTimestamp = exports.getSecondsTimestamp = void 0;
/**
 * Returns a numerical timestamp in seconds: 512969520
 * @hidden
 */
var getSecondsTimestamp = function (_a) {
    var date = _a.date;
    return Math.floor(date.getTime() / 1000);
};
exports.getSecondsTimestamp = getSecondsTimestamp;
/**
 * Returns a numerical timestamp in milliseconds: 512969520900
 * @hidden
 */
var getMillisecondsTimestamp = function (_a) {
    var date = _a.date;
    return date.getTime();
};
exports.getMillisecondsTimestamp = getMillisecondsTimestamp;
//# sourceMappingURL=timestamp.js.map